import Component from '../abstracts/Component';
import {SmoothScroll} from '../utils/SmoothScroll';

export default class HeroZoomComponent extends Component {
  get SELECTORS() {
    return {
      main: '.js-hero-zoom',
      layer: '.js-zoom-layer',
      steps: '.js-zoom-step',
      image: '.js-hero-zoom-image',
      header: '.main-header',

    }
  }

  get CLASSES() {
    return {
      visible: 'is-visible',
      animate: 'animate'
    }
  }

  get TIMING() {
    return {
      timeout: 600
    }
  }

  get SCROLL_DIRECTION() {
    return {
      up: 'up',
      down: 'down'
    }
  }

  constructor() {
    super();
    this.scrollDirection = 'down';
  }

  setScene(comp) {
    return new Promise((resolve, reject) => {
      try {
        this.main = comp;
        this.animationEnded = true;
        this.stepInfo = {
          steps: Array(),
          done: Array(),
        };
        resolve(true);
      } catch (e) {
        reject(e);
      }
    });
  }

  resetScene() {
    if (this.main) {
      const image = this.main.querySelector(this.SELECTORS.image);
      this.main.removeAttribute('data-step-initial');
      this.main.querySelector(this.SELECTORS.layer).classList.remove(this.CLASSES.visible);
      this.main.querySelector(this.SELECTORS.layer).classList.remove(this.CLASSES.animate);
      this.main.removeAttribute('data-animation-ended');
      this.animationEnded = true;
      this.stepInfo = {
        steps: Array(),
        done: Array(),
      };

      image.removeAttribute('style');
    }
  }

  between(point, from, to) {
    if (point < from) {
      return from;
    }
    if (point > to) {
      return to;
    }
    return point;
  }

  getSteps(comp) {
    return new Promise((resolve, reject) => {
      try {
        const steps = comp.querySelectorAll(this.SELECTORS.steps);
        steps.forEach(step => {

          let zoom = step.dataset.stepZoom;
          let transformx = step.dataset.stepTransformX;
          let transformy = step.dataset.stepTransformY;

          // console.warn('zoom before ' + zoom + " transform X " + transformx + " transform Y " + transformy);

          if (zoom == 1) {
            transformy = this.between(transformy, 0, 0);
            transformx = this.between(transformx, -50, 0);
          } else if (zoom > 1) {
            if(zoom == 2)
              transformy = this.between(transformy, -25, 25);
            else if(zoom == 3)
              transformy = this.between(transformy, -33, 33);
            transformx = this.between(transformx, -50, 25 * zoom);
          }

          // console.warn('zoom after ' + zoom + " transform X " + transformx + " transform Y " + transformy);

          let stepData = {
            id: step.dataset.stepId,
            transform: `scale3d(${zoom}, ${zoom}, ${zoom}) translate3d(${transformx}%, ${transformy}%, 0)`,
          };
          this.stepInfo.steps.push(stepData);
        });

        resolve(true);
      } catch (e) {
        console.error(e);
        reject(false);
      }
    });
  }

  animateLayer() {
    return new Promise((resolve, reject) => {
      try {
        this.main.setAttribute('data-step-initial', true);
        this.main.querySelector(this.SELECTORS.layer).classList.add(this.CLASSES.animate);
        this.main.querySelector(this.SELECTORS.layer).classList.add(this.CLASSES.visible);
        resolve(true);
      } catch (e) {
        reject(e)
      }
    });
  }

  animateImage() {
    return new Promise((resolve, reject) => {
      try {
        let actualStep = this.stepInfo.steps.shift();
        this.stepInfo.done.push(actualStep);

        if (actualStep) {
          const layer = document.querySelector(this.SELECTORS.layer);
          const step = layer.querySelector(`[data-step-id="${actualStep.id}"]`);
          const image = this.main.querySelector(this.SELECTORS.image);

          [...step.parentElement.children].forEach(sibling => {
            sibling.classList.remove(this.CLASSES.visible);
          });

          image.setAttribute('style', `transform: ${actualStep.transform}`);
          step.classList.add(this.CLASSES.visible);
          setTimeout(() => {
            resolve(true)
          }, this.TIMING.timeout);
        }

        if (this.stepInfo.steps.length === 0) {
          setTimeout(() => {
            this.captureScroll(true);
            document.body.style.overflow = '';
            this.main.setAttribute('data-animation-ended', true);
          }, this.TIMING.timeout);
        }


      } catch (e) {
        reject(e)
      }
    });
  }

  animateScroll() {
    return new Promise((resolve, reject) => {
      try {
        let initial = !this.main.dataset.stepInitial;

        if (initial) {
          this.animateLayer().then(res => {
            this.animateImage().then(res => resolve(true)).catch(err => reject(err));
          }).catch(err => {
            reject(err)
          });
          return;
        }

        this.animateImage().then(res => resolve(true)).catch(err => reject(err));

      } catch (e) {
        reject(e);
      }
    });
  }

  handleScroll() {

    this.captureScroll(true);
    if (this.animationEnded && document.body.style.overflow === 'hidden') {
      this.animationEnded = false;
      this.animateScroll().then(res => {
        setTimeout(() => {
          this.animationEnded = res;
          this.captureScroll();
        }, this.TIMING.timeout);
      });
    }
    return false;
  }


  captureScroll(unbind) {
    if (!unbind) {
      document.scrollingElement.addEventListener('mousewheel', e => this.handleScroll(), false);
      document.scrollingElement.addEventListener('DOMMouseScroll', e => this.handleScroll(), false);
    } else {
      document.scrollingElement.removeEventListener('mousewheel', e => this.handleScroll(), false);
      document.scrollingElement.removeEventListener('DOMMouseScroll', e => this.handleScroll(), false);
    }
  }

  bindPageScroll(components) {
    this.$on('scroll.herozoom', (e) => {
      this.scrollDirection = e.deltaY > 0 ? 'down' : 'up';
      components.forEach(comp => this.init(comp));
    });
  }

  getHeaderHeight() {
    const header = document.querySelector('.main-header');
    const benefitHeight = document.querySelector('.js-benefit-bar').clientHeight;
    let headerHeight;
    if (header.classList.contains('expanded')) {
      headerHeight = header.clientHeight;
    } else if (header.classList.contains('collapsed')) {
      const navigation = document.querySelector('.navigation');
      headerHeight = navigation ? navigation.clientHeight : 0;
    } else {
      headerHeight = header.clientHeight;
    }

    return benefitHeight + headerHeight;
  }

  init(comp) {
    const headerHeight = this.getHeaderHeight();
    const rect = comp.getBoundingClientRect();
    const isVisible = rect.top > headerHeight && rect.top <= window.innerHeight / 3;
    const isOut = rect.top + comp.clientHeight <= 0 || rect.bottom - comp.clientHeight > window.innerHeight;
    const hasZoomPoints = comp.querySelector(this.SELECTORS.layer);

    if (isOut) this.resetScene();

    if (!isVisible || !hasZoomPoints || comp.dataset.animationEnded) return;
    document.body.style.overflow = 'hidden';
    comp.scrollIntoView({
      block: 'center',
      inline: 'center'
    });

    this.setScene(comp).then(res => {
      this.getSteps(comp).then(res => {
        if (res) {
          this.captureScroll();
        }
      });
    });
  }

  render() {
    if (document.querySelector(this.SELECTORS.main) && this.$matchMedia(null, 'sm')) {
      const components = (document.querySelectorAll(this.SELECTORS.main));
      this.bindPageScroll(components);
      components.forEach(comp => this.init(comp));
    }
  }
}
